import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import {
  BackendView,
  View,
  ViewIdType,
} from '../../viewsSearch/types/ViewTypes';
import { transformBackendViewToInternalFormat } from '../../viewsSearch/dataOperators/backendViews';

export const SINGLE_VIEW_BY_ID_QUERY_NAME = 'singleViewById' as const;

export type FetchSingleViewQueryType = {
  id?: ViewIdType;
  objectTypeId: string;
  namespaceName: string;
};

type RawFetchSingleViewResponseType = BackendView;

const viewsSearchQueryArgsArgument = [
  'id',
  'objectTypeId',
  'namespaceName',
] satisfies (keyof FetchSingleViewQueryType)[];

export const SingleViewByIdQuery = registerQuery<
  typeof SINGLE_VIEW_BY_ID_QUERY_NAME,
  FetchSingleViewQueryType,
  View
>({
  fieldName: SINGLE_VIEW_BY_ID_QUERY_NAME,
  args: viewsSearchQueryArgsArgument,
  fetcher: (args) => {
    if (!args.id) {
      throw new Error('SingleViewByIdQuery: missing id in query args');
    }
    return http
      .get<RawFetchSingleViewResponseType>(
        `/sales/v4/views/${args.objectTypeId}/${args.id}?namespace=${args.namespaceName}`,
        {
          data: args,
        }
      )
      .then(transformBackendViewToInternalFormat);
  },
});

export const useFetchSingleView = (query: FetchSingleViewQueryType) => {
  return useQuery(SingleViewByIdQuery, {
    variables: query,
    skip: !query.id,
  });
};
